/**
 * Opens the question and vacancy dialogs.
 *
 * Triggers stay on the old Popup Builder classes:
 * `.sg-popup-id-16976` (header) and `.sg-popup-id-19291` (vacancy).
 */
(function () {
    'use strict';

    const triggers = {
        'sg-popup-id-16976': 'techkorm-popup-question',
        'sg-popup-id-19291': 'techkorm-popup-vacancy'
    };

    let lastFocus = null;

    const openPopup = (popup, trigger) => {
        lastFocus = trigger;
        popup.hidden = false;
        document.body.classList.add('techkorm-popup-open');

        const closeButton = popup.querySelector('.techkorm-popup__close');

        if (closeButton) {
            closeButton.focus();
        }
    };

    const closePopup = (popup) => {
        popup.hidden = true;

        if (!document.querySelector('.techkorm-popup:not([hidden])')) {
            document.body.classList.remove('techkorm-popup-open');
        }

        if (lastFocus && typeof lastFocus.focus === 'function') {
            lastFocus.focus();
        }
    };

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.sg-popup-id-16976, .sg-popup-id-19291');

        if (trigger) {
            const className = trigger.classList.contains('sg-popup-id-19291')
                ? 'sg-popup-id-19291'
                : 'sg-popup-id-16976';
            const popup = document.getElementById(triggers[className]);

            if (!popup) {
                return;
            }

            event.preventDefault();
            openPopup(popup, trigger);
            return;
        }

        const closer = event.target.closest('[data-techkorm-popup-close]');

        if (!closer) {
            return;
        }

        const popup = closer.closest('.techkorm-popup');

        if (popup) {
            closePopup(popup);
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }

        document.querySelectorAll('.techkorm-popup:not([hidden])').forEach(closePopup);
    });
}());
